import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import PageWrapper from '/components/page-wrapper'

import HelpText from '/help/account-management-api-keys'
import { AppContext } from '/providers/app-context'

import Menu from '/components/account/nav-menu'
import ApiKeyAdmin from '/components/account/api-keys'

const AccountManagementContact = () => {

  const navigate = useNavigate()
  const { client, user, selectedClientId } = useContext(AppContext)

  if (!user?.permissions.client_admin) navigate("../password")

  return (
    <PageWrapper title="API Key Management" HelpText={HelpText} heading="API Key Management" menu={<Menu client={client} user={user} selectedClientId={selectedClientId}/>}>
      <div className='flex flex-col'>
        <ApiKeyAdmin />
      </div>
    </PageWrapper>
  )
}

export default AccountManagementContact
